import { useState, useEffect, useSyncExternalStore } from "react";
import { navigate, replaceUrl, getPath, getSearchQuery, subscribeSearchParams } from "../lib/router.ts";

function useSearchQuery() {
  return useSyncExternalStore(subscribeSearchParams, getSearchQuery, () => "");
}

export function SearchBar() {
  const urlQuery = useSearchQuery();
  const [local, setLocal] = useState(urlQuery);

  // Sync from URL → local (e.g. back button, other input)
  useEffect(() => {
    setLocal(urlQuery);
  }, [urlQuery]);

  function handleChange(value: string) {
    setLocal(value);
    const q = value.trim();
    if (q) {
      if (getPath() !== "/search") {
        navigate(`/search?q=${encodeURIComponent(q)}`);
      } else {
        replaceUrl(`/search?q=${encodeURIComponent(q)}`);
      }
    } else if (getPath() === "/search") {
      navigate("/");
    }
  }

  return (
    <div className="flex-1 max-w-xs">
      <div className="relative">
        <input
          type="text"
          value={local}
          onChange={(e) => handleChange(e.target.value)}
          placeholder="search for an alternative..."
          className="w-full bg-transparent border border-border rounded-none px-3 py-1.5 pl-8 text-xs text-text-primary placeholder-text-muted focus:outline-none focus:border-accent/50 transition-colors font-mono"
        />
        <svg className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3 h-3 text-text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
    </div>
  );
}
